import React from "react";
import Deck from "./deck";
import "./deck2.css";
function dec2() {
  return (
    <div className="deckback">
      <Deck />
    </div>
  );
}
export default dec2;
